import styled from "styled-components";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ theme }) => theme.secondary};
  padding: 30px 10px 0px 10px;
  border-radius: 20px;
  line-height: 1.6;
  min-height: 300px;
  max-width: 380px;
  transition: background-color 0.3s ease-in;

  &:first-of-type {
    border: 1px solid ${({ theme }) => theme.borderCard};
  }

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const CardPlan = styled.div`
  .LogoVault {
    display: flex;
    flex-direction: row;
    margin-bottom: auto;
  }
  img {
    width: 70px;
  }
`;

export const Vault = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-family: "Roboto", "Montserrat", sans-serif;
  font-weight: 700;
  width: 100px;
  height: 35px;
  padding: 8px;
  background: ${({ theme }) => theme.vault};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 20px;
  transition: background-color 0.3s ease-in;

  @media (max-width: 1024px) {
    font-size: 18px;
    padding: 20px 40px 20px 40px;
  }
`;

export const TextPlan = styled.div`
  transition: background-color 0.3s ease-in;
  color: ${({ theme }) => theme.text};

  .TitlePlan {
    font-size: 18px;
    font-weight: bold;

    @media (max-width: 600px) {
      font-size: 24px;
    }
  }

  .DescriptionPlan {
    font-size: 15px;
    margin-bottom: auto;

    @media (max-width: 600px) {
      font-size: 17px;
    }
  }

  .PricePlan {
    display: flex;
    align-items: flex-start; 
    gap: 8px; 
    font-size: 22px;
    font-weight: 600;
    margin-bottom: auto;

    @media (max-width: 600px) {
      font-size: 24px;
    }
  }

  .PricePlan > div:first-child {
    color: #dddf22;
    font-size: 24px;
    font-weight: bold;
  }

  .PricePlan > div:last-child {
    font-size: 18px;
    align-self: flex-start;
    transform: translateY(5px);
    color: ${({ theme }) => theme.text};
  }
`;
